<template>
  <div class="pc-components">
    <div
      style="border-radius: 4px; background-color: #ffffff; padding: 20px 0 5px"
    >
      <div class="pc-components-item" v-for="item in list" :key="item.id">
        <div v-if="item.isShow" class="pc-components-item-main">
          <div v-if="parseInt(item.fieldType, 10) === 44"></div>
          <template v-else>
            <div class="label" v-if="parseInt(item.fieldType, 10) !== 11">
              <div
                class="required"
                v-if="
                  parseInt(item.requrein, 10) !== 1 &&
                  parseInt(item.fieldType, 10) !== 11
                "
              ></div>
              {{ item.name }}
            </div>
            <child-components
              v-model="item.value"
              :full-data="item"
              :commondata="commondata"
              v-if="parseInt(item.fieldType, 10) !== 11"
              @changeCity="changeCityInfo"
              @change="changeImageInfo"
              @changeValue="changeValueInfo"
              :disabled="disabled"
            >
            </child-components>
            <div
              class="pc-particulars"
              v-if="
                parseInt(item.fieldType, 10) === 11 && isShowDetailArea(item)
              "
            >
              <div class="pc-particulars-title">
                {{ item.name }}
              </div>
              <div class="pc-particulars-list">
                <div
                  class="pc-particulars-item"
                  v-for="(cItem, cIndex) in item.sub"
                  :key="cIndex"
                >
                  <div
                    class="pc-particulars-item-details particulars-title"
                    v-if="item.sub.length > 1"
                  >
                    <div class="particulars-title-label">
                      {{ cIndex > 8 ? cIndex + 1 : '0' + (cIndex + 1) }}
                    </div>
                    <el-tooltip content="删除明细行" v-if="!disabled">
                      <div
                        class="el-icon el-icon-delete"
                        @click="deleteParticulars(item.sub, cIndex)"
                      ></div>
                    </el-tooltip>
                  </div>
                  <div
                    class="pc-particulars-item-details"
                    v-for="(sItem, sIndex) in cItem"
                    :key="sIndex"
                  >
                    <div
                      v-if="sItem.isShow"
                      class="pc-particulars-item-details-main"
                    >
                      <div class="label">
                        <div
                          class="required"
                          v-if="parseInt(sItem.requrein, 10) !== 1"
                        ></div>
                        {{ sItem.name }}
                      </div>
                      <child-components
                        :commondata="commondata"
                        v-model="sItem.value"
                        :full-data="sItem"
                        @changeCity="changeCityInfo"
                        @change="changeImageInfo"
                        :disabled="disabled"
                        @changeValue="changeValueInfo"
                      >
                      </child-components>
                    </div>
                  </div>
                </div>
              </div>
              <el-button
                type="primary"
                class="add-pc-particulars"
                icon="el-icon-plus"
                @click="addParticulars(item)"
                v-if="!disabled"
              >
                添加{{ item.name }}
              </el-button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <flow-component v-if="flowInfo" :data="flowInfo"> </flow-component>
  </div>
</template>
<script>
import childComponents from './childComponents'
import flowComponent from './flowComponent'

export default {
  props: ['list', 'disabled', 'commondata'],
  components: { childComponents, flowComponent },
  computed: {
    flowInfo() {
      let info = this.list[this.list.length - 1]
      if (info && parseInt(info.fieldType, 10) === 44) {
        return info
      }
      return null
    },
  },
  methods: {
    isShowDetailArea(item) {
      return item.isShow
    },
    changeImageInfo(itemData, value) {
      itemData.value = [value]
      this.$emit('change', itemData)
    },
    changeCityInfo(itemData, value) {
      itemData.value = value
      this.$emit('change', itemData)
    },
    changeValueInfo(itemData) {
      this.$emit('change', itemData)
    },
    /**
     * @description 添加新的明细行
     * @param itemData
     */
    addParticulars(itemData) {
      let newParticulars = JSON.parse(JSON.stringify(itemData.sub[0]))
      newParticulars.map((item) => {
        if (parseInt(item.fieldType, 10) === 29) {
          item.value = null
        } else if (parseInt(item.fieldType, 10) === 5) {
          item.singleList = []
        } else {
          item.value = null
        }
      })
      itemData.sub.push(newParticulars)
    },
    /**
     * @description 删除指定明细行
     * @param itemData
     * @param index
     */
    deleteParticulars(itemData, index) {
      itemData.splice(index, 1)
    },
  },
}
</script>
<style lang="scss">
.pc-components {
  overflow: auto;
  .pc-components-item {
    > div {
      display: flex;
      justify-content: flex-start;
      line-height: 40px;
      padding: 0 20px;
      margin-bottom: 12px;

      .components {
        width: calc(100% - 10px);
        margin-left: 10px;

        .el-input {
          display: flex;
          justify-content: flex-start;
          position: relative;

          .el-input__inner {
            width: 100%;

            &.with-suffix {
              padding-right: 70px;
            }
          }

          .el-input-group__append {
            position: absolute;
            right: 0;
            top: 2px;
            width: 70px;
            text-align: center;
            line-height: 36px;
            border: none;
            background-color: transparent;
          }
        }

        .el-select-info {
          width: 100%;

          .select-area {
            .el-select {
              margin-bottom: 10px;
              width: 100%;

              &:nth-last-child(1) {
                margin-bottom: 0;
              }
            }
          }
        }

        .address {
          margin-top: 10px;
        }

        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 178px;
          height: 178px;
          line-height: 178px;
          text-align: center;

          &:before {
            color: #ababab;
          }
        }

        .avatar {
          width: 178px;
          height: 178px;
          display: block;
        }
      }

      &.hide {
        display: none;
      }

      .label {
        width: 110px;
        text-align: right;
        font-size: 12px;
        line-height: 14px;
        margin-top: 12px;
        max-height: 28px;
        overflow: hidden;
        color: #333333;
        position: relative;
        display: flex;
        justify-content: flex-end;

        .required {
          &::before {
            font-size: 14px;
            content: '*';
            color: #f56c6c;
            margin-right: 5px;
            margin-top: 3px;
          }
        }
      }

      .pc-particulars {
        width: 100%;
        border: 1px solid #d7dce6;

        .add-pc-particulars {
          margin: 0 auto 12px;
          display: flex;
          justify-content: center;
        }

        .pc-particulars-title {
          width: 100%;
          background-color: #f5f7fa;
          border-bottom: 1px solid #d7dce6;
          padding-left: 20px;
          font-size: 12px;
          font-weight: bold;
          color: #333333;
        }

        .pc-particulars-list {
          width: 100%;

          .pc-particulars-item {
            margin-bottom: 12px;
            border-top: 1px solid #d9d9d9;
            padding: 12px 0 12px;

            &:nth-child(1) {
              border-top: 0;
            }

            .pc-particulars-item-details {
              .pc-particulars-item-details-main {
                display: flex;
                justify-content: flex-start;
                margin: 12px 12px 12px;
                width: calc(100% - 24px);
              }

              &.particulars-title {
                width: 100%;
                margin: 0;
                line-height: 20px;
                display: flex;
                justify-content: space-between;
                padding: 0 12px;

                .particulars-title-label {
                  color: #4694df;
                }

                .el-icon {
                  cursor: pointer;

                  &:hover {
                    color: #ff0000;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
